



































































import { Vue, Component, Prop, Watch } from "vue-property-decorator";

// Types
import { IProduct } from "@/models/products";

@Component
export default class InvoiceGenerationControl extends Vue {
  // Props

  @Prop({ required: true })
  public value!: number;

  @Prop({ default: -30 })
  public minValue!: number;

  @Prop({ default: false })
  public isDisabled!: boolean;

  @Prop({ default: false })
  public allowBrandInheritance!: boolean;

  @Prop({ default: null })
  public brandValue!: IProduct["create_invoice_term"];

  // Variables

  public inheritBrandDefault = this.$_.isNull(this.value);
  public localValue: number | null = this.inheritBrandDefault
    ? this.brandValue
    : this.value;

  // Computed

  public get label() {
    return this.$tc(
      "_sentence.invoice.generation_setting_label",
      Math.abs(this.localValue as number)
    );
  }

  public get summary() {
    return this.$t("_sentence.invoice.generation_setting_summary", {
      startDate: this.$moment().format("MMMM Do"),
      endDate: this.$moment()
        .add(this.localValue, "d")
        .format("MMMM Do")
    });
  }

  // Watchers

  @Watch("inheritBrandDefault")
  public onInheritBrandDefaultChange() {
    this.localValue = this.brandValue;
    this.onLocalValueChange();
  }

  @Watch("localValue")
  public onLocalValueChange() {
    this.$emit("input", this.inheritBrandDefault ? null : this.localValue);
  }

  @Watch("value", { immediate: true })
  public onPassedValueChange() {
    this.inheritBrandDefault = this.$_.isNull(this.value);
    this.localValue = this.inheritBrandDefault ? this.brandValue : this.value;
  }
}
